import captureSentryException from '../tracking/sentry/captureSentryException';

const interestRate = (value) => {
  try {
    const rounded = (Math.round(value * 100) / 100).toFixed(2);

    return `${rounded.replace('.', ',')}% a.m.`;
  } catch (e) {
    const extras = {
      value,
    };
    captureSentryException(e, extras);
    throw new Error(`Error formatting value to interestRate: ${e}`);
  }
};
export default interestRate;

export const interestRateAnnual = (value) => {
  const ir = interestRate(value);
  return ir.replace('a.m.', 'a.a.');
};
